/**
 * The Kirby writer field does not include rel="noreferrer noopener" to links
 * with target="_blank" automatically. That means, the users of the CMS could
 * potentially add links which might be risky.
 *
 * Workaround:
 */

export const initializeLinks = () => {
  const links = document.querySelectorAll('a[target="_blank"]')

  links.forEach(link => {
    if (!link.hasAttribute('rel')) {
      link.setAttribute('rel', 'noreferrer noopener')
    }
  })
}
